import React from 'react';
import { useTranslation } from 'next-i18next';
import styled, { css, useTheme } from 'styled-components';
import { Box, Image, Link, Text } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Box).attrs(function (_ref) {
  var miroverseHighlighted = _ref.theme.miroverseHighlighted;
  return {
    $py: miroverseHighlighted.container.verticalPadding,
    $px: miroverseHighlighted.container.horizontalPadding,
    $styles: {
      borderRadius: miroverseHighlighted.container.radius,
      backgroundColor: 'var(--wcds-colors-body-primary)'
    }
  };
}).withConfig({
  displayName: "CategoryHeroBanner__Container",
  componentId: "sc-j7gkty-0"
})([""]);
var MiroverseTitle = styled(Text).attrs(function (_ref2) {
  var miroverseHighlighted = _ref2.theme.miroverseHighlighted;
  return {
    as: miroverseHighlighted.title.as,
    $variant: miroverseHighlighted.title.variant,
    $styles: {
      fontWeight: miroverseHighlighted.title.fontWeight,
      color: miroverseHighlighted.title.color
    }
  };
}).withConfig({
  displayName: "CategoryHeroBanner__MiroverseTitle",
  componentId: "sc-j7gkty-1"
})({});
var ItemContainer = styled(Box).attrs(function (_ref3) {
  var miroverseHighlighted = _ref3.theme.miroverseHighlighted;
  return {
    $styles: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      paddingBottom: miroverseHighlighted.itemContainer.verticalPadding,
      paddingTop: miroverseHighlighted.itemContainer.verticalPadding
    }
  };
}).withConfig({
  displayName: "CategoryHeroBanner__ItemContainer",
  componentId: "sc-j7gkty-2"
})([""]);
export var ItemLink = styled(Link).withConfig({
  displayName: "CategoryHeroBanner__ItemLink",
  componentId: "sc-j7gkty-3"
})(["display:block;&:focus{", "}"], function (props) {
  return props.theme.normalizeStyles(props.theme.focus.outlines.withOffset);
});
var HeroBannerLink = styled(ItemLink).withConfig({
  displayName: "CategoryHeroBanner__HeroBannerLink",
  componentId: "sc-j7gkty-4"
})(["", ""], function (_ref4) {
  var miroverseHighlighted = _ref4.theme.miroverseHighlighted,
      _ref4$lineBottom = _ref4.lineBottom,
      lineBottom = _ref4$lineBottom === void 0 ? false : _ref4$lineBottom;
  return lineBottom && css(["border-bottom:1px solid ", ";"], miroverseHighlighted.itemContainer.link.dividerColor);
});
var ActionLink = styled(Link).attrs(function (_ref5) {
  var miroverseHighlighted = _ref5.theme.miroverseHighlighted;
  return {
    $variant: miroverseHighlighted.actionLink.variant,
    $color: miroverseHighlighted.actionLink.color,
    $size: miroverseHighlighted.actionLink.size,
    withArrow: miroverseHighlighted.actionLink.withArrow
  };
}).withConfig({
  displayName: "CategoryHeroBanner__ActionLink",
  componentId: "sc-j7gkty-5"
})(["", ""], function (_ref6) {
  var _ref6$theme = _ref6.theme,
      normalizeStyles = _ref6$theme.normalizeStyles,
      miroverseHighlighted = _ref6$theme.miroverseHighlighted;
  return normalizeStyles({
    fontSize: miroverseHighlighted.actionLink.fontSize,
    fontWeight: miroverseHighlighted.actionLink.fontWeight
  });
});
export var ItemDescription = styled(Text).attrs(function (_ref7) {
  var miroverseHighlighted = _ref7.theme.miroverseHighlighted;
  return {
    $styles: {
      fontSize: miroverseHighlighted.itemContainer.itemDescription.fontSize,
      lineHeight: miroverseHighlighted.itemContainer.itemDescription.lineHeight,
      color: miroverseHighlighted.itemContainer.itemDescription.color
    }
  };
}).withConfig({
  displayName: "CategoryHeroBanner__ItemDescription",
  componentId: "sc-j7gkty-6"
})([""]);
export var CategoryHeroBanner = function CategoryHeroBanner() {
  var _useTheme = useTheme(),
      miroverseHighlighted = _useTheme.miroverseHighlighted;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Container, {
    "data-track-place": "Hero Category Banner",
    children: [/*#__PURE__*/_jsxs(MiroverseTitle, {
      children: [t('miroverse-section-in-category-menu-initial'), " ", /*#__PURE__*/_jsx("br", {}), t('miroverse-section-in-category-menu-end')]
    }), /*#__PURE__*/_jsx(HeroBannerLink, {
      target: "_blank",
      href: '/miroverse/',
      children: /*#__PURE__*/_jsx(ItemContainer, {
        children: /*#__PURE__*/_jsx(Box, {
          $styles: {
            width: miroverseHighlighted.itemContainer.imageWidth
          },
          children: /*#__PURE__*/_jsx(Image, {
            name: "miroverse-profiles",
            "aria-hidden": true,
            src: 'https://images.ctfassets.net/qop92tnevinq/6YEjAd5p8dQnQAFqjx3HAV/d6cc387f649b467cf7c37c5c230c143e/miroverse_banner_faces_small.png'
          })
        })
      })
    }), /*#__PURE__*/_jsx(ActionLink, {
      target: "_blank",
      href: '/miroverse/',
      children: t('miroverse-cta-category-menu')
    })]
  });
};